export const language: any = {
  add_by_image: "사진으로 추가",
  add_image_by_camera: "카메라로 촬영하기",
  add_image_by_gallery: "사진 선택하기",
  loading: "맛있는 레시피를 준비중이에요.\n잠시만 기다려주세요.",
  retry: "다시 시도",
  cancel: "취소",
  yes: "네",
  no: "아니요",
  goToIngredient: "재료 분석하기",
  goToRecipe: "요리 분석하기",
  recipe: {
    title: "AI 레시피",
    analysis_results: "분석 결과",
    ingredients: {
      title: "재료 (1인분)",
      view_more: '{number}개의 재료 더보기',
      view_less: '접기',
    },
    how_to_cook: "조리 방법",
    go_to_detail: "AI 레시피 보기",
    description: "레시피 소개",
    calories: "칼로리 함량",
    time: "조리 시간",
    ingredient: "주재료",
    spice: "양념",
    tip: "TIP",
  },
  ingredient: {
    title: "사진 분석",
    analysis_results: "사진 분석 결과 재료는 다음과 같습니다.",
    add_to_cart: "장바구니 추가",
    add_to_my_ingredients: "재료추가",
  },
  msg: {
    not_ingredients: `이건 멋진 사진이지만,\n여긴 식재료 전용이라서요!\n다음엔 맛있는 재료를 찍어주세요,\n요리의 비밀이 기다리고 있어요!\nAI 쉐프로 이동할까요?`,
    // AC-01-MSG-01
    not_recipes: `음, 이건 요리가 아니군요!\n저희는 요리 사진만 분석할 수 있어요.\n완성된 요리 사진을 올려주세요.\n식재료 분석하러 이동할까요?`,
    not_found: "not_found",
    unknow: `요리나 재료 사진이 아닌 것 같아요.\n분석을 위해 요리나 재료 사진을 업로드해주시면\n더 잘 도와드릴 수 있어요!`,
    upload_fail: `일시적인 오류로 업로드에 실패했어요.\n잠시 후 다시 시도해주세요.`,
    error: `앗! 사진 분석이 잘 안됐어요.\n사진을 다시 선택하거나,\n더 선명한 사진으로 시도해볼까요?`,
    bothType: `사진에 재료와 요리가 같이 있어요!\n사진에서 어떤 것을 분석할지 선택해주세요.`
  },
}
